import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AddLearner } from "./AddLearner";
import { BillingDetails } from "./BillingDetails";
import { PaymentDetails } from "./PaymentDetails";
import { PersonalDetails } from "./PersonalDetails";
import { ReviewPersonalDetails } from "./ReviewPersonalDetails";
import { trackFunnel } from "../../../helpers/analytics";
import { StepProgressIndicator } from "../../../components/StepProgressIndicator";
import { bookingCourseHref, bookingStepSearch } from "../../../helpers/bookingNavigation";

export const Steps = () => {
  const [params] = useSearchParams();
  const bookingType = useSelector((state) => state.courses.bookingType);
  const learners = useSelector((state) => state.courses.learners);
  const selectedCourse = useSelector((state) => state.courses.selectedCourse);

  const isMultiple = bookingType !== "single";
  const navigate = useNavigate();

  const nextStepHandler = () => {
    const step = Number(params.get("step"));

    if (!isMultiple && step === 2) {
      navigate({
        search: bookingStepSearch(params, 4, selectedCourse?.pcode),
      });
      return;
    }
    if (step < 5) {
      navigate({
        search: bookingStepSearch(params, Number(step) + 1, selectedCourse?.pcode),
      });
    }
  };
  const prevStepHandler = () => {
    const step = Number(params.get("step"));
    if (!isMultiple && step === 4) {
      navigate({
        search: bookingStepSearch(params, 2, selectedCourse?.pcode),
      });
      return;
    }
    if (step > 1) {
      navigate({
        search: bookingStepSearch(params, Number(step) - 1, selectedCourse?.pcode),
      });
    } else {
      navigate(bookingCourseHref(params, selectedCourse?.pcode));
    }
  };

  const step = Number(params.get("step"));

  useEffect(() => {
    if (!params.get("step") || (!learners.length && step !== 1)) {
      navigate({
        search: bookingStepSearch(params, 1, selectedCourse?.pcode),
      });
    }
  }, []);

  // Funnel: fire a step-view event each time the step changes (GA4 drop-off tracking).
  useEffect(() => {
    const names = { 1: "view_personal_details", 2: "view_billing", 3: "view_add_learners", 4: "view_review", 5: "view_payment" };
    if (names[step]) trackFunnel(names[step], { funnel_step: step });
  }, [step]);

  return (
    <>
      <StepProgressIndicator step={step} isMultiple={isMultiple} />
      {step === 1 && (
        <PersonalDetails
          nextHandler={nextStepHandler}
          prevHandler={prevStepHandler}
        />
      )}
      {step === 2 && (
        <BillingDetails
          nextHandler={nextStepHandler}
          prevHandler={prevStepHandler}
        />
      )}
      {step === 3 && (
        <AddLearner
          nextHandler={nextStepHandler}
          prevHandler={prevStepHandler}
        />
      )}
      {step === 4 && (
        <ReviewPersonalDetails
          nextHandler={nextStepHandler}
          prevHandler={prevStepHandler}
        />
      )}
      {step === 5 && (
        <PaymentDetails
          nextHandler={nextStepHandler}
          prevHandler={prevStepHandler}
        />
      )}
    </>
  );
};
